import React from "react";

import {
  KeyboardArrowDown,
} from "@mui/icons-material";
import { Typography, ButtonBase, Menu, MenuItem } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";


const PlanDropDown = ({ value, data, onChange, placeholder, triggerStyles = {}, dropdownStyles = {}, dropDownItemStyles = {} }) => {
  return (
    <PopupState>
      {(popupState) => (
        <>
          <ButtonBase sx={{ fontSize: '14px', gap: .5, ...triggerStyles }} {...bindTrigger(popupState)}>
            {value || placeholder || 'select'}{" "}
            <KeyboardArrowDown
              sx={{ width: "16px", height: "16px" }}
            />
          </ButtonBase>
          <Menu {...bindMenu(popupState)} sx={{ ...dropdownStyles }}>
            {data?.map((d) => (
              <MenuItem
                sx={{ ...dropDownItemStyles }}
                key={d}
                onClick={() => {
                  onChange(d);
                  popupState.close();
                }}
              >
                <Typography sx={{ fontSize: '14px', fontFamily: 'Outfit' }}>{d}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

export default PlanDropDown;
